const theme = {
  breakpoints: ["767.98px", "1023.98px"], // or something else?
  fonts: {
    default: "HelveticaNeue Light",
  },
  fontSizes: {
    normal: "13px",
    listbox: "14.5px",
    label: "15px",
    title: "19px",
  },
  lineHeights: {
    normal: "normal",
    input: "35px",
  },
  colors: {
    background: "#fcfcfc",
    text: "#000",
    primary: "#2f80b6",
    white: "#fff",
    table: "#d8d8d8",
    hover: "#f9f9f9",
    warning: "#ffa500",
  },
  borders: {
    default: "1px solid #d1d1d4",
    notification: "1px solid #868b8e",
  },
  radii: {
    default: "3px",
    notification: "12px",
    round: "50%",
  },
  shadows: {
    focus: "0 0 2px #427e98",
    notification: "2px 2px 1px -1px #ddd",
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  sizes: {
    input: "35px",
    button: "115px",
    notification: "350px",
    "price-input-lg": "165px",
    "price-input": "72px",
    "table-row": "60px",
  },
}

export default theme
